module.exports = __webpack_public_path__ + "img/jianshe.560aba3e.png";